module.exports = __webpack_public_path__ + "static/media/27.839178ca.jpg";